"use strict";

$(function () {
  $('.js-private-menu').on('click', function () {
    if ($(this).is('.open')) {
      unfixBody();
    } else {
      fixBody();
    }

    $(this).toggleClass('open');
    $('.js-main-private').toggleClass('open-menu-private');
    $('.js-private-nav').toggleClass('is-open');
    $('.js-panel-private').toggleClass('open-menu-private');
  });
});